export function isAgentActive(agent) {
  if (!agent) return false
  return agent.hasAcceptedInvitation && !agent.archived
}

export function isAgentNotArchived(agent) {
  if (!agent) return false
  return !agent.archived
}

export const compareRole = (a, b, direction = 'ASC') => {
  // Role sort: the ASC order is the same as roles in the array (the order isn't alphabetical)
  const roles = ['owner', 'admin', 'agent']
  const roleAIndex = roles.indexOf(a.role?.toLowerCase())
  const roleBIndex = roles.indexOf(b.role?.toLowerCase())
  return direction === 'ASC' ? roleAIndex - roleBIndex : roleBIndex - roleAIndex
}
